import {Grid} from '@material-ui/core';
import {AccentColorOptions, useBreakpointDown} from 'epic-ue-theme';
import React from 'react';
import styled from 'styled-components';
import {UeLink} from '../../wraps';
import {Button, CmsButtonProps} from '../buttons';
import {Eyebrow} from '../eyebrow';
import {RadiantEyebrow} from '../eyebrow/RadiantEyebrow';
import {LightboxButton, LightboxButtonProps} from '../lightbox';
import {VerticalSpacer} from '../spacer';
import {Typography as Text} from '../typography';

const HeadingTitle = styled.div<{accentColor?: AccentColorOptions}>`
    .ue-link-wrap-span:hover {
        color: ${(p) => (p.accentColor ? p.theme.palette.accent[p.accentColor] : 'initial')};
        transition: color 0.25s ${(p) => p.theme.easing};
    }
`;

export interface ImageAndTextCardContentProps {
    heading?: string;
    title?: string;
    eyebrow?: string;
    radiantEyebrow?: boolean;
    description?: string;
    accentColor?: AccentColorOptions;
    button?: CmsButtonProps;
    noBottomSpacer?: boolean;
    lightboxButton?: LightboxButtonProps;
}

export const ImageAndTextCardContent = ({
    heading,
    title,
    eyebrow,
    description,
    accentColor,
    button,
    radiantEyebrow,
    noBottomSpacer,
    lightboxButton
}: ImageAndTextCardContentProps): JSX.Element => {
    const isSm = useBreakpointDown('sm');

    return (
        <Grid className="itc-content" item xs={12} sm={12} md={4} lg={4} xl={4}>
            <VerticalSpacer variant="custom" spacing={0} downSmSpacing={3} />
            {eyebrow && (
                <div className="eyebrow-container">
                    {radiantEyebrow ? (
                        <RadiantEyebrow text={eyebrow} as="span" accentColor={accentColor} />
                    ) : (
                        <Eyebrow text={eyebrow} as="span" />
                    )}
                    <VerticalSpacer variant="custom" spacing={3} downSmSpacing={2} />
                </div>
            )}
            {(heading || title) && (
                <HeadingTitle className="heading-title" accentColor={accentColor}>
                    <Text variant="h2" as="h3">
                        <UeLink href={(button && !button.label && button.href) || ''}>
                            {heading || title}
                        </UeLink>
                    </Text>
                    {!noBottomSpacer && (description || (button && button.label)) && <VerticalSpacer variant="custom" spacing={2} downSmSpacing={1} />}
                </HeadingTitle>
            )}
            {description && (
                <div className="description">
                    <Text variant="p" color="secondary">
                        {description}
                    </Text>
                </div>
            )}
            {lightboxButton?.label ? (
                <LightboxButton {...lightboxButton} />
            ) : (
                button &&
                button.label && (
                    <div key="itc-content-btn-wrap">
                        <VerticalSpacer variant="custom" spacing={3} downSmSpacing={2} />
                        <Button type={button.type} href={button.href} color={accentColor}>
                            {button.label}
                        </Button>
                    </div>
                )
            )}

            {!noBottomSpacer && isSm && <VerticalSpacer variant="section" />}
        </Grid>
    );
};
